<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">公告编辑</span>
    </div>
    <el-form ref="dialogForm" :model="dialogForm" label-width="100px">
      <el-form-item label="公告分类">
        <el-select v-model="dialogForm.b2cNoticeTypeId" clearable placeholder="请选择平台">
          <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.noticeTypeName"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="公告标题">
        <el-input v-model="dialogForm.noticeTitle" style="width: 50%;"></el-input>
      </el-form-item>
      <el-form-item label="添加时间">
        <el-date-picker
            v-model="dialogForm.createTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <div>文章排序是按照时间倒序， 请合理使用添加时间进行控制排序</div>
        <el-checkbox v-model="dialogForm.isTop">是否置顶</el-checkbox>
        <el-checkbox v-model="dialogForm.isNew">是否NEW</el-checkbox>
        <el-checkbox v-model="dialogForm.isNeed">是否必填</el-checkbox>
      </el-form-item>
      <el-form-item label="弹窗显示">
        <el-radio-group v-model="dialogForm.isShow">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="公告内容">
        <Editor  v-model="dialogForm.noticeContent"
        api-key="lm2j5zqtvc09mifvnhhmu7fdcdi54707pqrn05d3qkierr17"
        :init="init">
        </Editor>
      </el-form-item>
    </el-form>
  </el-card>
  <el-card>
    <el-row :gutter="30" style="text-align: center">
      <el-col :span="10" style="text-align: right">
        <el-button type="info" icon="el-icon-back">返回</el-button>
      </el-col>
      <el-col :span="10" style="text-align: left">
        <el-button type="primary" icon="el-icon-folder" @click="saveData">保存</el-button>
      </el-col>
    </el-row>
  </el-card>
</div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import Editor from "@tinymce/tinymce-vue"
import {addNotice, getAllNoticeType, sendImageToServer, updateNotice} from "../../api/b2cbusiness/b2c_admin";

export default {
name: "NoticeRelease",
  mixins: [MixinCUD],
  components:{
  Editor,
  },
  data(){
  return{
    options: [],
    dialogForm: {
      b2cNoticeTypeId:"",
      noticeTitle:""
    },
    init:{
      language:"zh_CN",
      browser_spellcheck: true, // 拼写检查
      branding: false, // 去水印
      elementpath: false, //禁用编辑器底部的状态栏
      statusbar: false, // 隐藏编辑器底部的状态栏
      paste_data_images: true, // 允许粘贴图像
      menubar: false, // 隐藏最上方menu
      plugins: 'lists link image table code help wordcount',
      image_title: false,
      automatic_uploads: true,
      toolbar: "fontselect fontsizeselect link lineheight forecolor backcolor bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | image quicklink h2 h3 blockquote table numlist bullist preview fullscreen", //工具栏
      fontsize_formats: "14px 16px 18px 20px 24px 26px 28px 30px 32px 36px", //字体大小
      font_formats:"微软雅黑=Microsoft YaHei,Helvetica Neue;PingFang SC;sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun;serifsans-serif;Terminal=terminal;monaco;Times New Roman=times new roman;times", //字体
      images_upload_handler: (blobInfo, success, failure) => {
        let formData;
        formData = new FormData();
        formData.append('file',blobInfo.blob(), blobInfo.filename());
        sendImageToServer(formData).then(res=>{
          if (res.success){
            success(res.data);
          }
        });
      }
    }
  }
  },
  mounted() {
    getAllNoticeType({pageNum:1, pageSize:20}).then(res => {
      if (res.success) {
        this.options = res.data.records;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });
    console.log(this.$route.query.noticData)
    if (this.$route.query.noticData){
      this.dialogForm = this.$route.query.noticData;
    }
  },
  methods:{
  saveData(){
    this.$confirm("确定提交数据么?")
        .then(_ => {
          if(this.dialogForm.id){ //有id是更新数据，没有id是新增数据
            updateNotice(this.dialogForm).then(res=>{
              if (res.success) {
                this.$message.success("更新数据成功")
                this.$router.back();
              }
            }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            });
          }else {
            addNotice(this.dialogForm).then(res=>{
              if (res.success) {
                this.$message.success("更新数据成功")
                this.$router.back();
              }
            }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            });
          }
          //取消新增或修改也要重置表单
        }).catch(err => {this.handleCloseDialog();});

  }
  }
}
</script>

<style scoped>

</style>
